export default "__VITE_ASSET__Do2U7r1L__"